import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, Input, notification} from 'antd';

import {getTill, updateTill} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout} from "../utils/style";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const TextArea = Input.TextArea;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class UpdateTillForm extends Component {
  componentDidMount() {
    this._loadBrand();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.tillId !== this.props.match.params.tillId) {
      this._loadBrand();
    }
  }

  _loadBrand = () => {
    const {tillId} = decodeParams(this.props.match.params);
    this.props.getTill({tillId});
  };

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {tillId} = decodeParams(this.props.match.params);
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.updateTill({...values, tillId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {till, form: {getFieldDecorator, getFieldsError}, loading} = this.props;
    const {name, description} = till;
    return (
      <Card title="Update Till">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              initialValue: name,
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Description"
          >
            {getFieldDecorator('description', {
              initialValue: description
            })(
              <TextArea />
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Update Till
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

UpdateTillForm.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  form: PropTypes.object.isRequired,
  till: PropTypes.object.isRequired,
  getTill: PropTypes.func.isRequired,
  updateTill: PropTypes.func.isRequired
};

const UpdateTillPage = Form.create()(UpdateTillForm);

const mapStateToProps = state => ({
  loading: state.till.gettingTill || state.till.updatingTill,
  till: state.till.till || {}
});

const mapDispatchToProps = dispatch => ({
  getTill: payload => (dispatch(getTill(payload))),
  updateTill: payload => (dispatch(updateTill(payload)))
});

export default connect(mapStateToProps, mapDispatchToProps)(UpdateTillPage);



// WEBPACK FOOTER //
// ./src/Till/UpdateTillPage.js